import { render, staticRenderFns } from "./ShowFormationPage.vue?vue&type=template&id=5c8808ff"
import script from "./ShowFormationPage.vue?vue&type=script&lang=js"
export * from "./ShowFormationPage.vue?vue&type=script&lang=js"
import style0 from "./ShowFormationPage.vue?vue&type=style&index=0&id=5c8808ff&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports